import { Directive, ElementRef, OnDestroy, Optional } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FocusManagerService } from '@sc/feature-focus-manager';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[sc-focus-return-zone], [scFocusReturnZone]',
  providers: [FocusManagerService],
  standalone: true,
})
export class FocusReturnZoneDirective implements OnDestroy {
  private readonly subs = new Subscription();

  constructor(
    @Optional() private readonly formGroup: FormGroupDirective,
    private readonly el: ElementRef<HTMLElement>,
    private readonly matDialog: MatDialog,
    private readonly focusManager: FocusManagerService
  ) {
    this.focusManager.setFocusElem(this.el.nativeElement);
    if (this.formGroup?.form) {
      this.focusManager.setFocusForm(this.formGroup.form);
    }

    this.subs.add(
      this.matDialog.afterAllClosed.subscribe(() => {
        this.focusManager.applyFocus();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
